import { Component, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { StepValidationState } from 'projects/reg-hub-client/src/interfaces/step';
import { EmptyEntityService, eOrderType, ePartyType, Order, OrderManagerService, PartiesFormComponent, Party, PartyRepositoryService, UIConfigurationService, Utilities, ValidationProblem, ValidationService } from 'reg-hub-common';
import { PartiesComponent } from '../parties/parties.component';

@Component({
    selector: 'app-debtor',
    templateUrl: './debtor.component.html',
    styleUrls: ['./debtor.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DebtorComponent extends PartiesComponent {
  @ViewChild(PartiesFormComponent) debtorForm!: PartiesFormComponent;

  protected businessDebtor = ePartyType.businessDebtor;
  protected individualDebtor = ePartyType.individualDebtor;
  protected defaultType = ePartyType.individualDebtor;

  protected debtor!: Party;

  constructor(
    partyRepository: PartyRepositoryService,
    uiConfigurationService: UIConfigurationService,
    orderManager: OrderManagerService,
    validationService: ValidationService,
    private emptyEntityService: EmptyEntityService) { 
    super(partyRepository, uiConfigurationService, orderManager, validationService);
  }

  public override init(order: Order): void {
    super.init(order);

    if (this.order.orderTypeID === eOrderType.landTitleSearch) {
      this.debtor = this.order.landTitleSearchCriteria?.party ?? this.emptyEntityService.getEmptyParty(this.defaultType);
    } else if (this.order.orderTypeID === eOrderType.knowYourCustomer) {
      this.debtor = this.order.knowYourCustomerCriteria?.party ?? this.emptyEntityService.getEmptyParty(this.individualDebtor);
    } else {
      this.debtor = order.parties?.find(party => Utilities.isDebtor(party)) || this.emptyEntityService.getEmptyParty(this.defaultType);
    }
  }

  public override getValidationState(errors: ValidationProblem[] | undefined, order: Order): StepValidationState {
    return StepValidationState.ValidationSuccess;
  }

  protected override getParties(): Party[] {
    return this.order.parties!.filter(party => Utilities.isDebtor(party));
  }

  public override onSaving(): void {
    const debtor = this.debtorForm.getParty();

    if (this.order.orderTypeID === eOrderType.landTitleSearch) {
      this.order.landTitleSearchCriteria!.party = debtor;
    } else if (this.order.orderTypeID === eOrderType.knowYourCustomer) {
      this.order.knowYourCustomerCriteria!.party = debtor;
    } else {
      this.order.debtor = debtor;

      const nonDebtors = this.order.parties?.filter(party => party.partyTypeID !== ePartyType.businessDebtor && party.partyTypeID !== ePartyType.individualDebtor);
      this.order.parties = nonDebtors;
      this.order.parties?.push(debtor);
    }

    this.orderManager.updateOrder(this.order);
  }
}
